// extracted by mini-css-extract-plugin
module.exports = {"paginator":"paginator__v_H2x"};